import { Component, OnInit } from '@angular/core';
import { PurchaseOrder, PurchaseOrderLine } from './orders.model';
import { ContactModel } from '../../contact/contact/contact.model';
import { ContactService } from '../../contact/contact/contact.service';
import { ConceptService } from '../concept/concept.service';
import { OrdersService } from './orders.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';

@Component({
    selector: 'app-orders-create',
    templateUrl: './orders-create.component.html',
    styleUrls: ['./orders-create.component.css'],
    standalone: false
})
export class OrdersCreateComponent implements OnInit {

  selectedProviderName = '';
  contactList: ContactModel[] = [];
  ready = false;
  edit = false;
  order: PurchaseOrder = new PurchaseOrder();
  uid: string = '00000000-0000-0000-0000-000000000000';
  view = false;

  displayedColumns: string[] = ['productName', 'quantityOrdered', 'price'];
  conceptRows: PurchaseOrderLine[] = [];

  constructor(
    private contactService: ContactService,
    private conceptService: ConceptService,
    private orderService: OrdersService,
    private route: ActivatedRoute,
    private router: Router,
    protected snackBar: MatSnackBar,
  ) { }

  async ngOnInit(): Promise<void> {
    const mode = this.route.snapshot.data['mode'];
    this.view = mode === 'view';

    this.contactList = await this.contactService.getListProviders();

    this.uid = this.route.snapshot.paramMap.get('uid');

    if (this.uid && this.uid !== '00000000-0000-0000-0000-000000000000') {
      this.edit = true;
      this.orderService.getOrder(this.uid).subscribe(order => {
        this.order = order;

        this.selectedProviderName = this.contactList.find(c => c.uid === this.order.supplierUid).companyName;

        this.conceptService
          .getListRelations(this.order.supplierUid)
          .then((relations: any[]) => {

            const orderLines = this.order.lines || [];

            this.conceptRows = relations.map(relation => {

              const existingLine = orderLines.find(
                l => l.productUid === relation.uid
              );

              if (existingLine) {
                return {
                  ...existingLine,
                  productName: relation.name,
                  unitPrice: relation.price,
                  price: relation.price * existingLine.quantityOrdered
                } as PurchaseOrderLine;
              }

              return {
                productUid: relation.uid,
                productName: relation.name,
                quantityOrdered: 0,
                quantityReceived: 0,
                unitPrice: relation.price,
                price: 0
              } as PurchaseOrderLine;
            });

          });

        this.ready = true;
      });

    } else {
      this.ready = true;
    }
  }

  updateQuantity(line: PurchaseOrderLine, value: any) {
    let qty = parseInt(value, 10);
    if (isNaN(qty) || qty < 0) {
      qty = 0;
    }
    line.quantityOrdered = qty;
    line.price = line.unitPrice * qty;
  }

  onSelectContact(providerUid: string) {
    this.order.supplierUid = providerUid;

    this.conceptService.getListRelations(providerUid).then((response: any[]) => {
      this.conceptRows = response.map(item => {
        let quantity = 0;
        if (item.units !== undefined && item.units !== null) {
          quantity = 0;
        }

        let unitPrice = 0;
        if (item.price !== undefined && item.price !== null) {
          unitPrice = item.price;
        }

        return {
          productUid: item.uid,
          productName: item.name,
          quantityOrdered: quantity,
          quantityReceived: 0,
          unitPrice: unitPrice,
          price: unitPrice * quantity
        } as PurchaseOrderLine;
      });
    });
  }

  save() {
    this.order.lines = this.conceptRows;
    if (this.order.lines.length === 0) {
      this.displayInfo('Debe agregar al menos un producto al pedido.');
      return;
    }
    this.orderService.createOrder(this.order).subscribe(response => {
      this.router.navigate(['/concept/orders']);
    });
  }

  update() {
    this.order.lines = this.conceptRows;
    this.orderService.updateOrder(this.uid, this.order).subscribe(response => {
      this.router.navigate(['/concept/orders']);
    });
  }

  public displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, '', options);
  }

  goBack(){
    this.router.navigate(['/concept/orders']);
  }

}
